import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncRouteList = lazy(() => import('~/containers/RouteList'));

export default [
  <Route path="/routes">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncRouteList />
    </Suspense>
  </Route>,
];
